module.exports = __webpack_public_path__ + "img/slide2.8fd4f733.jpg";